import { registerLocaleData } from '@angular/common'
import localeEs from '@angular/common/locales/es'
import localeFr from '@angular/common/locales/fr'
import { bootstrapApplication } from '@angular/platform-browser'

import { initializeLanguage } from '@yoshu-lib/core/config/language.factory'

import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'

registerLocaleData(localeFr)
registerLocaleData(localeEs)

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => initializeLanguage(appRef.injector))
  .catch((err) => console.error(err))
